import React, { useState, useEffect, useContext } from "react";

import styles from "./styles/CredentialsMenu.module.css";
// import CredStored from "./CredStored";
// import CredNotStored from "./CredNotStored";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import CredStored from "../Edit Asset/CredStored";
import CredNotStored from "../Edit Asset/CredNotStored";

function CredentialsMenu({ onChange, formErrors }) {
  const [election, setElection] = useState(1);
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.EditAsset.CredentialsMenu
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.EditAsset.CredentialsMenu);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const elections = [
    dublicatedcontent.dublicatedText60,
    content.credentialsMenuText2,
    content.credentialsMenuText3,
  ];
  let CredentialOptions = null;
  switch (election) {
    case 1:
      CredentialOptions = null;
      break;
    case 2:
      CredentialOptions = (
        <CredStored onChange={onChange} formErrors={formErrors} />
      );
      break;
    case 3:
      CredentialOptions = (
        <CredNotStored onChange={onChange} formErrors={formErrors} />
      );
      break;
    default:
      break;
  }
  useEffect(() => {
    onChange({ record_name: "This assets has no credentials" });
  }, []);
  return (
    <>
      <div className={styles.menu}>
        <div
          onClick={() => {
            setElection(1);
            onChange({ record_name: "This assets has no credentials" });
          }}
          className={styles.main}
        >
          <div className={styles.deactivated}>
            {election === 1 ? <div className={styles.activated} /> : null}
          </div>
          <div className={styles.option}>{elections[0]}</div>
        </div>
        <div onClick={() => setElection(2)} className={styles.main}>
          <div className={styles.deactivated}>
            {election === 2 ? <div className={styles.activated} /> : null}
          </div>
          <div className={styles.option}>{elections[1]}</div>
        </div>
        <div onClick={() => setElection(3)} className={styles.main}>
          <div className={styles.deactivated}>
            {election === 3 ? <div className={styles.activated} /> : null}
          </div>
          <div className={styles.option}>{elections[2]}</div>
        </div>
        <div
          style={{ order: election === 2 ? 2 : election === 3 ? 3 : "unset" }}
        >
          {CredentialOptions}
        </div>
      </div>
    </>
  );
}

export default CredentialsMenu;
